import React from 'react';

import Icon from './Icon';
import EditPencil from './EditPencil';
import { initialsFromName } from '../lib/mandate-helpers';

// Single employee card used in the v3 Employees list (cards mode).
//
//   ┌────────────────────────────────────────┐
//   │  ⊙   Dean Birkett                       │
//   │ DB   Founding Director                  │
//   │      Advisory · Cape Town               │
//   │      BCom (Hons), CA(SA)                │
//   │      ✉ dean.b@bsm.international         │
//   └────────────────────────────────────────┘

interface Props {
  name: string;
  role: string; // e.g. "Founding Director"
  team?: string; // e.g. "Advisory"
  office?: string; // e.g. "Cape Town"
  qualifications?: string; // free-text comma list
  email?: string;
  onClick?: () => void;
  onEdit?: () => void;
}

const EmployeeCard = ({
  name,
  role,
  team,
  office,
  qualifications,
  email,
  onClick,
  onEdit
}: Props) => (
  <article
    className="emp-card"
    onClick={onClick}
    role={onClick ? 'button' : undefined}
    tabIndex={onClick ? 0 : undefined}
    onKeyDown={
      onClick
        ? (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onClick();
            }
          }
        : undefined
    }
  >
    {onEdit && <EditPencil onClick={onEdit} ariaLabel={`Edit ${name}`} />}
    <div className="emp-av">{initialsFromName(name)}</div>
    <div className="body">
      <div className="name">{name}</div>
      <div className="role">{role}</div>
      {(team || office) && <div className="meta">{[team, office].filter(Boolean).join(' · ')}</div>}
      {qualifications && <div className="quals">{qualifications}</div>}
      {email && (
        <a className="mail" href={`mailto:${email}`} onClick={(e) => e.stopPropagation()}>
          <Icon name="mail" size={12} />
          {email}
        </a>
      )}
    </div>
  </article>
);

export default EmployeeCard;
